export function cloneJSON(obj) {
    return JSON.parse(JSON.stringify(obj));
}
